import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaTimes, FaCheck, FaTrash } from "react-icons/fa";
import { CheckBoxInput } from "../../../../Buttons";
import { returnEuroString } from "../../../../../../helpers/Utils";
import { Tooltip } from "antd";
import { createPartialInvoice } from "../../../../../../redux/Actions/orderAction";
import { orderInvoiceRemove } from "../../../../../../redux/Actions/order_invoice_action";
import { have_product_reference } from "../../../../../../helpers/OrdersFunctionsGlobal";
import ForwardProformaInvoice from "./ForwardProformaInvoice";
import ButtonSecondary from "../../../../ButtonSecondary";
import { IconExclamation } from "../../../../../Layout/Icons";

const PopoverInvoiceChildren = ({
  setPartialInvoice,
  invoices,
  partialInvoice,
  shipments,
  order_rows,
  order_cart_rules_info,
  carrier_info,
  order_id,
  mode,
  show_checkbox,
  real_order_id,
}) => {
  console.log({ order_id, real_order_id });
  const dispatch = useDispatch();
  const {
    user: { role },
  } = useSelector((state) => state.auth);
  let order_cart_rules = [];
  let carrier = {};
  if (order_id) {
    order_cart_rules = order_cart_rules_info;
    carrier = carrier_info;
  } else {
    const {
      order: { carrier: carrier_redux, order_cart_rules: order_cart_rules_redux },
    } = useSelector((state) => state.orders);
    order_cart_rules = order_cart_rules_redux;
    carrier = carrier_redux;
  }
  const [selectedCarrier, setSelectedCarrier] = useState(false);
  const [carrierUsedInvoiceNumbers, setCarrierUsedInvoiceNumbers] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(true);
  const [discountUsedInvoiceNumbers, setDiscountUsedInvoiceNumbers] = useState(
    []
  );
  const [selected_rows, set_selected_rows] = useState([]);
  const [skipInvoice, set_skip_invoice] = useState(false);
  const [skipDuplicates, setSkipDuplicates] = useState(false);
  const [forwardProformaData, setForwardProformaData] = useState({
    email: "",
    subject: "",
    message: "",
  });

  useEffect(() => {
    const buildSelecttedOrderRows = () => {
      let initialRows = order_rows.map((e) => {
        const quantities = !have_product_reference(e.product_reference)
          ? 1
          : e?.product_info?.product_suppliers &&
            Array.isArray(e?.product_info?.product_suppliers)
            ? e?.product_info?.product_suppliers
              ?.filter((fl) => !fl?.supplier?.name.startsWith("virtual"))
              ?.reduce((sum, li) => sum + +li.quantity, 0) || 0
            : e?.product_info?.product_suppliers_total || 0;

        return {
          selected: false,
          isUsed: false,
          id: e.id,
          quantities,
          shipment_counts: 0,
        };
      });

      shipments
        .filter((e) => !e.deleted_at)
        .forEach((e) => {
          e?.shipment_order_rows
            ?.filter((d) => (d.deleted_at ? false : !d.canceled_at))
            .forEach((sor) => {
              const findIndex = initialRows.findIndex(
                (fi) => sor.order_row_id == fi.id
              );
              if (findIndex !== -1) {
                if (initialRows[findIndex].quantities > 0) {
                  initialRows[findIndex].selected = true;
                  initialRows[findIndex].shipment_counts += sor.quantity;
                  order_rows
                    .filter(
                      ({ parent_id, product_reference }) =>
                        ["{}", "", null].includes(product_reference) &&
                        parent_id == sor.order_row_id
                    )
                    .forEach((r) => {
                      const findIndex = initialRows.findIndex(
                        (fi) => r.id == fi.id
                      );
                      if (findIndex !== -1) {
                        if (initialRows[findIndex].quantities > 0) {
                          initialRows[findIndex].selected = true;
                        }
                      }
                    });
                }
              }
            });
        });

      if (invoices.length == 0) {
        setSelectedCarrier(true);
        setCarrierUsedInvoiceNumbers([]);
        setDiscountUsedInvoiceNumbers([]);
      } else {
        setSelectedCarrier(true);
        const carrier_used_invoice_numbers = [];
        const discount_used_invoice_numbers = [];
        invoices.forEach((e) => {
          if (e.shipping) {
            setSelectedCarrier(false);
            carrier_used_invoice_numbers.push(e.invoice_number);
          }
          if (e.discount) {
            setSelectedDiscount(false);
            discount_used_invoice_numbers.push(e.invoice_number);
          }
          e.order_invoice_order_rows.forEach((d) => {
            if (!!d.api_error) return;
            const findIndex = initialRows.findIndex(
              (fi) => d.order_row_id == fi.id
            );
            if (findIndex !== -1) {
              initialRows[findIndex].selected = false;
              initialRows[findIndex].isUsed = true;
              if (!initialRows[findIndex].isUsedInvoiceNumbers)
                initialRows[findIndex].isUsedInvoiceNumbers = [];

              initialRows[findIndex].isUsedInvoiceNumbers.push(
                e.invoice_number
              );
            }
          });
        });
        setCarrierUsedInvoiceNumbers(carrier_used_invoice_numbers);
        setDiscountUsedInvoiceNumbers(discount_used_invoice_numbers);
      }
      if (order_cart_rules?.length == 0) {
        setSelectedDiscount(false);
      }

      console.log({ initialRows });
      if (mode == "pre_invoice") {
        set_selected_rows(
          initialRows.map((e) => ({
            ...e,
            selected: true,
            isUsed: false,
          }))
        );
        setSelectedCarrier(true);
        setCarrierUsedInvoiceNumbers([]);
        setDiscountUsedInvoiceNumbers([]);
        setSelectedDiscount(order_cart_rules?.length > 0);
      } else {
        set_selected_rows(initialRows);
      }
    };
    buildSelecttedOrderRows();
  }, [invoices.length]);

  const handleCheckBoxOrdersSelected = (id) => {
    const newChecked = [...selected_rows];
    const currentIndexCheck = newChecked.findIndex((e) => e.id == id);
    const services = order_rows.filter(({ parent_id }) => parent_id == id);

    const value = !newChecked[currentIndexCheck].selected || false;
    newChecked[currentIndexCheck].selected = value;

    services.forEach((service) => {
      const findService = selected_rows.findIndex((e) => e.id == service.id);
      newChecked[findService].selected = value;
    });
    set_selected_rows(newChecked);
  };

  const removeDalineSaskaita = (item_id) => {
    if (confirm("Are you sure want to delete?")) {
      return dispatch(orderInvoiceRemove(item_id, order_id));
    }
    console.log("Remove daline saskaita!!!");
  };

  const partialInvoiceFunc = async () => {
    const order_rows_used = selected_rows
      .filter((e) => e.selected)
      .map((e) => e.id);
    setPartialInvoice({
      ...partialInvoice,
      loading: true,
      children_loading: true,
    });
    try {
      if (
        shipments.length == 0 &&
        !confirm("Are you sure want to create invoice?")
      ) {
        return setPartialInvoice({ code: null, error: null, loading: false });
      }

      // func to check
      const itsLastInvoice = () => {
        // const goods_order_rows = order_rows;
        if (invoices.length == 0) {
          if (order_rows.length == order_rows_used.length) return true;
        } else {
          let invoice_order_rows_used = [...order_rows_used];
          invoices.forEach((e) =>
            e.order_invoice_order_rows.forEach((d) =>
              invoice_order_rows_used.push(d.order_row_id)
            )
          );
          invoice_order_rows_used = [...new Set(invoice_order_rows_used)];
          if (invoice_order_rows_used.length == order_rows.length) {
            return true;
          }
        }
        return false;
      };

      // end
      const its_last_invoice = itsLastInvoice();
      const pre_invoice = mode == "pre_invoice";
      const data = await dispatch(
        createPartialInvoice(real_order_id, {
          order_rows: order_rows_used,
          order_cart_rules: selectedDiscount,
          carrier_id: selectedCarrier,
          pre_invoice: pre_invoice,
          its_last_invoice,
          skip_invoice: skipInvoice,
          forward_proforma: pre_invoice ? forwardProformaData : {},
          skip_duplicates: skipDuplicates,
        })
      );
      setPartialInvoice(data);
    } catch (err) {
      console.log("Error: ", err);
      setPartialInvoice({
        ...partialInvoice,
        loading: false,
        children_loading: false,
      });
    }
  };

  const updateStateFunc = (func) => {
    func((prev) => !prev);
  };

  return (
    <div>
      <div className="col-12 px-0">
        {invoices.length > 0 && (
          <div className="mb-1">
            {invoices.map((e) => (
              <div key={e.id} className="mb-2">
                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <b>
                      Invoice: {e.invoice_number}{" "}
                      {e.identifier == "pre_invoice" &&
                        " - ( Forward invoice )"}
                      {e?.user_title && ` - ${e.user_title}`}
                    </b>
                    {["admin", "accounting"].includes(role) && (
                      <FaTrash
                        className="text-danger cursor-pointer"
                        onClick={() => removeDalineSaskaita(e.id)}
                      />
                    )}
                  </div>
                  <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <span className="mr-1">
                      Discounts:{" "}
                      {e.discount ? (
                        <FaCheck className="text-success ml-1" />
                      ) : (
                        <FaTimes className="text-danger ml-1" />
                      )}
                    </span>
                    <span className="mr-1">
                      Delivery:
                      {e.shipping ? (
                        <FaCheck className="text-success ml-1" />
                      ) : (
                        <FaTimes className="text-danger ml-1" />
                      )}
                    </span>
                    <span className="mr-1">
                      Email sent:{" "}
                      {e.email_sent_at ? (
                        <FaCheck className="text-success ml-1" />
                      ) : (
                        <FaTimes className="text-danger ml-1" />
                      )}
                    </span>
                    <span className="mr-1">
                      Goods: {e?.order_invoice_order_rows?.length || 0}
                    </span>
                  </div>
                </div>
                {e?.order_invoice_order_rows
                  .filter(({ api_error }) => !!api_error)
                  .map(({ id, api_error, order_row_id }, idx) => (
                    <React.Fragment key={id}>
                      {idx > 0 && <hr className="my-1" />}
                      <div className="text-danger text-sm d-flex align-items-center">
                        <IconExclamation className="mr-2" />
                        {order_rows.find((order_row) => order_row.id == order_row_id)?.product_name}: {api_error}
                      </div>
                    </React.Fragment>
                  ))}
                <div></div>
              </div>
            ))}
            <hr />
          </div>
        )}
        {show_checkbox && (
          <CheckBoxInput
            text={<b>Don’t create export invoice</b>}
            checked={skipInvoice}
            onChange={() => set_skip_invoice((prev) => !prev)}
          />
        )}
        <RenderUsedCheckBox
          text={<b>Delivery</b>}
          checked={selectedCarrier}
          usedInvoiceNumbers={carrierUsedInvoiceNumbers}
          onChange={() => updateStateFunc(setSelectedCarrier)}
        />
        <div>{carrier.name}</div>
        {order_cart_rules?.length > 0 && (
          <Fragment>
            <hr />
            <RenderUsedCheckBox
              text={<b>Discounts</b>}
              checked={selectedDiscount}
              usedInvoiceNumbers={discountUsedInvoiceNumbers}
              onChange={() => updateStateFunc(setSelectedDiscount)}
            />
          </Fragment>
        )}
        <div>
          {order_cart_rules.map((e) => (
            <div key={e.id}>
              {e.title} - {returnEuroString(e.total)}
            </div>
          ))}
        </div>
        <hr />
        <b>Services</b>
        <div>
          {order_rows
            .filter((e) => ["{}", "", null].includes(e.product_reference))
            .map((e) => (
              <div key={e.id}>
                <RenderCheckBox
                  id={e.id}
                  text={`${Math.floor(e?.quantity)}x ${e.product_name}
                ${returnEuroString(e.unit_price_tax_incl)}`}
                  isProduct={false}
                  selected_rows={selected_rows}
                  handleCheckBoxOrdersSelected={handleCheckBoxOrdersSelected}
                />
              </div>
            ))}
        </div>
        <hr />
        <b>Products</b>
        <div>
          {order_rows
            .filter((e) => !["{}", "", null].includes(e.product_reference))
            .map((e) => (
              <div key={e.id}>
                <RenderCheckBox
                  id={e.id}
                  text={`${Math.floor(e?.quantity)}x ${e.product_name}
                ${returnEuroString(e.unit_price_tax_incl)}`}
                  isProduct={true}
                  selected_rows={selected_rows}
                  handleCheckBoxOrdersSelected={handleCheckBoxOrdersSelected}
                />
              </div>
            ))}
        </div>
      </div>
      <hr
        style={{
          marginRight: "-16px",
          marginLeft: "-16px",
        }}
      />
      <div className="d-flex justify-content-between mt-2">
        <CheckBoxInput
          text="Do not check for duplicates"
          checked={skipDuplicates}
          onChange={() => updateStateFunc(setSkipDuplicates)}
        />
        <div
          style={{
            width: 120,
          }}
        >
          <ButtonSecondary
            className={`generate_inv ${mode == "pre_invoice" ? "invisible" : ""
              }`}
            loading={partialInvoice.children_loading}
            onClick={async () => {
              await partialInvoiceFunc();
            }}
          >
            Generate invoice
          </ButtonSecondary>
        </div>
      </div>
      {mode == "pre_invoice" && (
        <ForwardProformaInvoice
          order_id={real_order_id}
          setForwardProformaData={setForwardProformaData}
          forwardProformaData={forwardProformaData}
        />
      )}
    </div>
  );
};

export default PopoverInvoiceChildren;

const RenderUsedCheckBox = ({
  text,
  checked,
  usedInvoiceNumbers,
  onChange,
}) => {
  if (!checked && usedInvoiceNumbers?.length > 0) {
    return (
      <div className="d-block">
        <Tooltip
          placement="top"
          title={`Used in ${usedInvoiceNumbers.join(", ")}`}
        >
          <label className="ant-checkbox-wrapper cursor-pointer" onClick={onChange}>
            <span className="ant-checkbox" style={{ top: 0 }}>
              <span className="ant-checkbox-inner d-flex justify-content-center align-items-center">
                <FaTimes color="#ff9e00" />
              </span>
            </span>
            <span className="checkbox_text">{text}</span>
          </label>
        </Tooltip>
      </div>
    );
  }
  return <CheckBoxInput text={text} checked={checked} onChange={onChange} />;
};

const RenderCheckBox = ({
  id,
  text,
  isProduct,
  selected_rows,
  handleCheckBoxOrdersSelected,
}) => {
  const findItem = selected_rows.find((som) => som.id == id);
  // console.log({ findItem });
  if (findItem?.isUsed && findItem?.selected == false) {
    return (
      <Tooltip
        placement={"left"}
        title={isProduct ? `Residues: ${findItem.quantities}` : "Service"}
      >
        <div>
          <Tooltip
            placement="top"
            title={`Used in ${findItem?.isUsedInvoiceNumbers?.join(", ")}`}
          >
            <label
              className="ant-checkbox-wrapper cursor-pointer"
              onClick={() => handleCheckBoxOrdersSelected(id)}
            >
              <span className="ant-checkbox" style={{ top: 0 }}>
                <span className="ant-checkbox-inner d-flex justify-content-center align-items-center">
                  <FaTimes color="#ff9e00" />
                </span>
              </span>
              <span
                className={`checkbox_text ${findItem?.quantities == 0 ? "text-danger" : ""
                  }`}
              >
                {text}
                {!!findItem?.shipment_counts && (
                  <span className="text-warning">
                    {" "}
                    Shipment units: {findItem?.shipment_counts}
                  </span>
                )}
              </span>
            </label>
          </Tooltip>
        </div>
      </Tooltip>
    );
  }
  return (
    <Tooltip
      placement={"left"}
      title={isProduct ? `Residues: ${findItem?.quantities || 0}` : "Service"}
    >
      <div>
        <CheckBoxInput
          text={
            <span className={findItem?.quantities == 0 ? "text-danger" : ""}>
              {text}
              {!!findItem?.shipment_counts && (
                <span className="text-warning">
                  {" "}
                  Shipment units: {findItem?.shipment_counts}
                </span>
              )}
            </span>
          }
          checked={findItem?.selected ? true : false}
          onChange={() => handleCheckBoxOrdersSelected(id)}
        />
      </div>
    </Tooltip>
  );
};
